const DEFAULT_TITLE = 'Deccos Impact Management Software';
const DEFAULT_FAVICON = '/favicon.ico';

/**
 * Zet de titel en het tabblad-icoontje van het browservenster naar de huisstijl
 * van het webadres (whitelabel).
 *
 * Het tabblad-icoontje is een eigen veld, want het logo is een liggend
 * beeldmerk met de merknaam erin en een tabblad-icoontje is vierkant: zet je
 * daar het logo neer, dan drukt de browser het plat tot een onleesbaar streepje.
 * Ontbreekt `favicon`, dan valt hij terug op het logo -- dat was de stand tot
 * 2026-09-23 en blijft kloppen voor merken die nog geen eigen icoontje hebben.
 *
 * @param {object} props
 * @param {string} [props.compagnyName] - Merknaam uit ImpactManagers.Name; wordt de venstertitel
 * @param {string} [props.logo] - Logo-adres uit ImpactManagers.Logo; 'none' betekent 'geen logo'
 * @param {string} [props.favicon] - Adres van het vierkante icoontje uit ImpactManagers.Favicon
 */
const applyDocumentBranding = ({ compagnyName, logo, favicon } = {}) => {
  if (typeof document === 'undefined') return;

  document.title = compagnyName || DEFAULT_TITLE;

  const link = document.querySelector("link[rel='icon']");
  if (!link) return;

  const icon = [favicon, logo].find((value) => value && value !== 'none');
  link.href = icon || DEFAULT_FAVICON;
};

export default applyDocumentBranding;
